import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { KEY_CODES } from 'constants'

import styles from 'containers/ClanLanding/components/ClanQuestsTutorial/ClanQuestsTutorialView.scss'
import Back from 'components/Back/Back'
import { Pagination } from 'components/Pagination/Pagination'
import { generateYouTubeLink, video } from 'components/Youtube/YoutubeVideo'
import {
    AFFIRMATIVE_BUTTON,
    CLAN_QUEST_TUTORIAL_DESCRIPTION,
    CLAN_QUEST_TUTORIAL_TITLE,
    PAGE_2_DESCRIPTION,
    PAGE_2_TITLE,
    PAGE_3_DESCRIPTION,
    PAGE_3_TITLE,
    PAGE_4_DESCRIPTION,
    PAGE_4_TITLE,
} from 'containers/ClanLanding/components/ClanQuestsTutorial/translations'
import { Button } from 'react-wot-bootstrap'

const maxPagesCount = 4
export class ClanQuestsTutorialView extends React.PureComponent {
    static propTypes = {
        videoId: PropTypes.string.isRequired,
        language: PropTypes.string.isRequired,
        isCNRealm: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
    }

    videoAPI

    constructor(props) {
        super(props)

        this.state = {
            pageIndex: 0,
        }
        this.videoAPI = video.loadAPI()
    }

    componentDidMount() {
        window.addEventListener('keydown', this.onKeyDown)

        this.videoAPI.then(() => {
            video.createPlayer('youtube-video', false)
        })
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.onKeyDown)

        this.videoAPI.then(() => {
            video.destroyPlayer('youtube-video')
        })
    }

    onKeyDown = (e) => {
        if (e.keyCode !== KEY_CODES.ESCAPE) {
            return
        }
        this.props.onClose()
    }

    handleClanQuestIntroPageUpdate = (pageIndex) => {
        this.setState({ pageIndex })
    }

    renderPage = () => {
        switch (this.state.pageIndex) {
        case 0: {
            return this.props.isCNRealm ? (
                <video
                    controls
                    className={styles.video}
                    disablePictureInPicture
                    controlsList="nodownload noremoteplayback"
                >
                    <source src={this.props.videoId} type="video/webm" />
                </video>
            ) : (
                <iframe
                    className={styles.video}
                    id={'youtube-video'}
                    sandbox={'allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation'}
                    src={generateYouTubeLink(this.props.videoId, this.props.language)}
                    allowFullScreen
                />
            )
        }
        case 1: {
            return (
                <div className={classNames(styles.page, styles.page2)}>
                    <div className={styles.img}/>
                    <div className={styles.content}>
                        <div className={styles.contentTitle}>{PAGE_2_TITLE}</div>
                        <div className={styles.contentDescription}>{PAGE_2_DESCRIPTION}</div>
                    </div>
                </div>
            )
        }
        case 2: {
            return (
                <div className={classNames(styles.page, styles.page3)}>
                    <div className={styles.img}/>
                    <div className={styles.content}>
                        <div className={styles.contentTitle}>{PAGE_3_TITLE}</div>
                        <div className={styles.contentDescription}>{PAGE_3_DESCRIPTION}</div>
                    </div>
                </div>
            )
        }
        case 3: {
            return (
                <div className={classNames(styles.page, styles.page4)}>
                    <div className={styles.img}/>
                    <div className={styles.content}>
                        <div className={styles.contentTitle}>{PAGE_4_TITLE}</div>
                        <div className={styles.contentDescription}>{PAGE_4_DESCRIPTION}</div>
                    </div>
                </div>
            )
        }
        default: {
            return null
        }
        }
    }

    render() {
        return (
            <div className={styles.base}>
                <div className={styles.closeButton}>
                    <Back
                        type={Back.TYPES.close}
                        side={Back.SIDES.right}
                        caption={Back.CAPTIONS.close}
                        handleClick={this.props.onClose}
                    />
                </div>
                <div className={styles.wrapper}>
                    <div className={styles.paginationCounter}>{`${this.state.pageIndex + 1} / ${maxPagesCount}`}</div>
                    <div className={styles.title}>{CLAN_QUEST_TUTORIAL_TITLE}</div>
                    <div className={styles.description}>{CLAN_QUEST_TUTORIAL_DESCRIPTION}</div>
                    <Pagination
                        className={styles.pagination}
                        onChange={this.handleClanQuestIntroPageUpdate}
                        pagesCount={maxPagesCount}
                        hasPageButtons={false}
                        hasArrow
                    >
                        {this.renderPage()}
                    </Pagination>
                    <div className={styles.divider}/>
                    <Button mixClassName={styles.affirmativeButton} onClick={this.props.onClose}>
                        {AFFIRMATIVE_BUTTON}
                    </Button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/ClanQuestsTutorial/ClanQuestsTutorialView.jsx